/**
 * SSE (Server-Sent Events) Types
 * Generic types for the SSE subscription service
 */

// Stream types enum for type safety
export enum SSEStreamType {
    NEW_BILLS = 'new-bills',
    ORDER_UPDATES = 'order-updates',
}

// Request body for subscription
export interface SSESubscribeRequest {
    streamType: SSEStreamType;
    shopId: string;
}

// Common event data structures
export interface SSEHeartbeatData {
    timestamp: string;
}

export interface SSEConnectedResultData {
    message: string;
    shopId: string;
    timestamp: string;
}

export interface SSEConnectedData {
    httpStatusCode: number;
    customStatusCode: number | null;
    result: {
        data: SSEConnectedResultData;
        customData: null;
    };
    message: string;
    displayMessage: string;
    status: 'OK';
}

export interface SSEErrorData {
    httpStatusCode: number;
    customStatusCode: number | null;
    result: {
        data: null;
        customData: null;
    };
    message: string;
    displayMessage: string;
    status: 'Failure';
}

// Order update event data structure
export interface OrderUpdateData {
    type: 'order';
    subType: 'incoming' | 'modification' | 'statusUpdate';
    status?: string;
    shopId: string;
    orderId: string;
    externalOrderId: string;
    title: string;
    body: string;
    orderType?: string;
    open_order_count?: string;
    newOrdersCount?: number;
    customerName?: string;
    customerPhone?: string;
    orderTotal?: string;
}

// SSE connection state
export type SSEConnectionState = 'connecting' | 'connected' | 'disconnected' | 'error';

// Event handlers type
export interface SSEEventHandlers<T = unknown> {
    onData: (data: T) => void;
    onConnected?: (data: SSEConnectedData) => void;
    onError?: (data: SSEErrorData | Error) => void;
    onHeartbeat?: (data: SSEHeartbeatData) => void;
}

// SSE connection control interface
export interface SSEConnection {
    close: () => void;
}
